const DonateButton = () => (
  <div style={{ textAlign: 'center', padding: '15px 0' }}>
    <a className='donateButton' href="https://send.monobank.ua/jar/92t3ZAYkma" target="_blank" rel="noreferrer">
      ДОЛУЧИТИСЬ
    </a>
  </div>
)

export default DonateButton;
